import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTMultiSelectComponent } from './components/lt-multiselect/lt-multiselect.component';
import { LTMultiSelectTComponent } from './components/lt-multiselect-t/lt-multiselect-t.component';
@NgModule({
  imports: [
    CommonModule,
    LTMultiSelectComponent,
    LTMultiSelectTComponent,
  ],
  exports: [
    LTMultiSelectComponent,
    LTMultiSelectTComponent,
  ],
})
export class LTMultiSelectModule { }